'use strict';

var translations = {
    warnings: {
        straightRow: '請避免使用鍵盤横行按鍵組合，例如 "asdf"。',
        simpleRepeat: '請避免重複字母或串字，例如 "aaa" 和 "abcabc"。',
        extendedRepeat: '請避免重複字母或串字，例如 "aaa" 和 "abcabc"。',
        sequences: '請避免使用例如 "abc" 或 "6543" 等的序列。',
        recentYears: '請避免近年年份，例如 "2020"。',
        dates: '請避免使用日期。',
        topTen: '請避免使用常見密碼。',
        topHundred: '請避免使用常見密碼。',
        common: '請避免使用常見密碼。',
        similarToCommon: '請避免使用常見密碼。',
        wordByItself: '請避免單獨使用一個詞語作為密碼。',
        namesByThemselves: '請避免單獨使用姓氏或名字作為密碼。',
        commonNames: '請避免單獨使用姓氏或名字作為密碼。',
        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: '請使用包含多於兩個詞語的一串長字符，避免用常用短語。',
        anotherWord: '請加入一至兩個詞語，使用較少見的詞語會更好。',
        repeated: '請避免重複字母或串字，例如 "aaa" 和 "abcabc"。',
        l33t: '請避免使用以 "@" 代替 "a" 等可預測的替換，例如 "@pple" 代替 "Apple"。',
        reverseWords: '請避免使用倒轉串寫的詞語，例如 "elppa"（將 "apple" 倒轉串寫）。',
        allUppercase: '全部大寫的密碼與全部小寫的密碼均容易猜到。',
        dates: '請避免使用日期。',
        associatedYears: '請避免使用日期。',
        recentYears: '請避免近年年份，例如 "2020"。',
        sequences: '請避免使用例如 "abc" 或 "6543" 等的序列。',
        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'less than a second',
        second: '{base} second',
        seconds: '{base} seconds',
        minute: '{base} minute',
        minutes: '{base} minutes',
        hour: '{base} hour',
        hours: '{base} hours',
        day: '{base} day',
        days: '{base} days',
        month: '{base} month',
        months: '{base} months',
        year: '{base} year',
        years: '{base} years',
        centuries: 'centuries',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
